<label class="label">{{topLabel}}</label>
<div class="switch-field"
     [class.enabled]="value">
  <span class="off">{{offLabel}}</span>
  <mat-slide-toggle class="switch"
                    color="primary"
                    [(ngModel)]="value"
                    [disabled]="isDisabled"
                    (change)="onSwitchChange($event)">
  </mat-slide-toggle>
  <span class="on">{{onLabel}}</span>
</div>
